import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Icon } from 'antd';

const TabView = React.createClass({
  getDefaultProps() {
    return { alwaysOpen: false };
  },

  render() {
    const panelButtons = _.isArray(this.props.children)
      ? this.props.children.map(this._createPanelButton)
      : this._createPanelButton(this.props.children, 0)

    const panels = _.isArray(this.props.children)
      ? this.props.children.map(this._createPanel)
      : this._createPanel(this.props.children, 0);

    return (
      <div className="TabView">
        <div className="TabView__panels">
          {panels}
        </div>
      </div>
    );
  },

  _onSelect(index) {
    const alreadySelected = this.props.selected === index;
    if (!alreadySelected || this.props.alwaysOpen) {
      this.setState({ selected: index });
    } else {
      this.setState({ selected: null });
    }
  },

  _onClose(index) {
    this.props.onClose();
  },

  _createPanel(child, index) {
    return React.cloneElement(child, {
      key: index,
      index: index,
      selected: index === this.props.selected,
      onClose: this._onClose,
    });
  },

  _createPanelButton(child, index) {
    return <PanelSelectButton
      key={index}
      index={index}
      header={child.props.header}
      selected={index === this.props.selected}
      onSelect={this._onSelect}
    />;
  },
});

TabView.Panel = React.createClass({
  getInitialState() {
    return {
      contentHeight: 0,
    };
  },

  componentDidMount() {
    this._setHeightState();
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      this._setHeightState();
    }
  },

  componentDidUpdate() {
    this._setHeightState();
  },

  render() {
    let className = 'TabView__panel';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    const style = {};
    if (this.props.selected) {
      style.transform = `translateY(-${this.state.contentHeight + 100}px)`;
    }

    return (
      <div className={className} style={style} ref={(div) => this.div = div}>
        <div className="TabView__panel-close-container">
          <a onClick={this._onClose}>
            <Icon className="bounce" type="down" />
          </a>
        </div>
        <div className="TabView__panel-content">
          <div ref={(div) => this.contentDiv = div}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  },

  _setHeightState() {
    const contentDivEl = ReactDOM.findDOMNode(this.contentDiv);
    const contentHeight = contentDivEl.clientHeight;
    if (contentHeight !== this.state.contentHeight) {
      this.setState({ contentHeight });
    }
  },

  _onClose() {
    this.props.onClose(this.props.index);
  }
});

const PanelSelectButton = React.createClass({
  render() {
    let className = 'TabView__panel-select-button';
    if (this.props.selected) {
      className += ' TabView__panel-select-button--selected'
    }
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    return (
      <div className={className}>
        <a onClick={this._onSelect}>
          {this.props.header}
        </a>
      </div>
    );
  },

  _onSelect() {
    this.props.onSelect(this.props.index);
  }
});

export default TabView;



// WEBPACK FOOTER //
// ./src/components/TabView.js